export const NewOrderMixin = {
	computed: {
		actualItemAmount() {
			return (item, orderQuantity, defaultCost) => {
				item.actualItemAmount = Number(orderQuantity * defaultCost).toFixed(2);
				// this.actualItems.length ? this.actualItems[index]. : 0
				return item.actualItemAmount;
			};
		},
		returnedItemAmount() {
			return (item, orderQuantity, defaultCost) => {
				item.returnedItemAmount = Number(orderQuantity * defaultCost).toFixed(
					2
				);
				return item.returnedItemAmount;
			};
		},
		actualItemsTotal() {
			return this.actualItems.reduce((acc, item) => {
				const actualAmount = Number(item.actualItemAmount) + Number(acc);
				return actualAmount % 1 != 0
					? Number(actualAmount).toFixed(2)
					: actualAmount;
			}, 0);
		},
		returnedItemsTotal() {
			return this.returnedItems.reduce((acc, item) => {
				const returnAmount = Number(item.returnedItemAmount) + Number(acc);
				return returnAmount % 1 != 0
					? Number(returnAmount).toFixed(2)
					: returnAmount;
			}, 0);
		},
		totalOrderAmount() {
			var total =
				Number(this.actualItemsTotal) - Number(this.returnedItemsTotal);
			console.log("total", total);
			return total % 1 != 0 ? total.toFixed(2) : total;
		}
	}
};
